import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { CmsPageService } from 'src/app/services/cms-page.service';
import { EcommerceTemplateService } from 'src/app/services/ecommerce-template.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-ecommercetemplate',
  templateUrl: './ecommercetemplate.component.html',
  styleUrls: ['./ecommercetemplate.component.scss']
})
export class EcommercetemplateComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

 
  data: any;
  templateList: any | null = null;
  selectedTemplate: any | null = null;


  firstFormGroup: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<EcommercetemplateComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    public formBuilder: UntypedFormBuilder,
    private cmsPageService: CmsPageService,
    private homePageService: HomePageService,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private ecommerceTemplateService: EcommerceTemplateService
  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
    this.data = data;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  currentUuid: any=1;

  title: any;

  public serverPath = environment.commonImageApi + "ecommerceTemplate/";

  ngOnInit() {
    this.getTemplateList();

    this.firstFormGroup = this.formBuilder.group({
      uuid: ['', [Validators.required]],
    });

    // this.currentUuid = this.data.value;

    // this.title = this.data.title;

  }


  //cms
  public cmsFilterControl: UntypedFormControl = new UntypedFormControl();
  cmsList: any;
  cmsTypeList: any;
  filteredCmsTypeList: any;

  getCmsList(accountName) {

    this.cmsPageService.getAllCmsDropDownByAccount(accountName).subscribe(
      res => {

        this.cmsList = res;
        this.cmsTypeList = res;
        this.filteredCmsTypeList = this.cmsTypeList;
      },
      error => {
      })

      this.CmsYFilter();

  }

  protected _onDestroy = new Subject<void>();

  CmsYFilter() {
    this.cmsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.CmsFilter();
      });
  }


  protected CmsFilter() {
    if (!this.cmsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.cmsFilterControl.value;
    if (!search) {
      this.filteredCmsTypeList = this.cmsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredCmsTypeList = this.cmsTypeList.filter(cms => cms['title']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllCmsSet() {
    this.filteredCmsTypeList = this.cmsTypeList;
  }

  getTemplateList() {
    this.ecommerceTemplateService.getAllTemplateDropDown().subscribe(
      (res: any[]) => {

        console.log(res);
        
        this.templateList = res;
     
      },
      (error) => {
        console.error('Error fetching templates:', error);
        this.templateList = [];
        this.snackBar.open('Failed to load templates. Please try again.', 'Close', { duration: 3000 });
      }
    );
  }

  selectTemplate(template: any) {
    this.selectedTemplate = template;

    console.log(template , "selectedTemplate");
    
    if (template.accountName != null) {
      this.getCmsList(template.accountName);
       this.CmsYFilter();
    }
  }

  uuid: any;

  saveTemplate(template) {
   

    this.uuid=template.accountName;

    this.currentUuid=1;

    this.title="Home Page";


    this.router.navigate([`page/duplicatePage/${this.title}/${this.currentUuid}/${this.uuid}/copytemplate`]);

    this.dialogRef.close({ event: 'close' })
  }

  viewTemplate(template: any): void {

    window.open(template, '_blank');
  }

  close(){
    this.dialogRef.close();
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}